import { all, takeEvery, put, call } from "redux-saga/effects";
import {
  fetchTokenFailure,
  fetchTokenSuccess,
  loginActionFail,
  loginActionSuccess,
  showLoader,
  hideLoader,
  LoginLoaderStutas,
} from "../../actions";
import CryptoJS from "crypto-js";
import * as allactions from "../../actions";
import * as actionLabels from "../../actionLabels";
import axiosMain from "../../../http/axios/axios_main";
import CustomToast from "../../../components/Toast";

function* loginSaga(action) {
  try {
    yield put(showLoader());
    const response = yield call(
      axiosMain.post,
      `/admin/auth/token`,
      action.payload
    );

    if (response.status === 200) {
      if (response.data.statusCode === 200) {
        // localStorage.clear();
        let responseData = response.data.responseData;
        // let responseData1 = response.data.responseData;
        // let responseData = decryptData(responseData1.toString());
        if (action.payload.userCode == responseData.userCode) {
          let userNameEncodeData =
            responseData.roleCode && responseData.roleCode.toString();
          let roleCodeLowerCase = userNameEncodeData.toLowerCase();
          //ROLE
          // sessionStorage.setItem(
          //   "User",
          //   JSON.stringify({
          //     userCode: userNameEncodeData === "BUYER" ? "buyer" : "auctioneer",
          //   })
          // );
          sessionStorage.setItem(
            "User",
            JSON.stringify({
              userCode: roleCodeLowerCase,
            })
          );
          localStorage.setItem(
            "User",
            JSON.stringify({
              userCode: roleCodeLowerCase,
            })
          );
          //   console.log(userNameEncodeData,"userNameEncodeData")
          // localStorage.setItem(
          //   "User",
          //   JSON.stringify({
          //     userCode: userNameEncodeData === "BUYER" ? "buyer" : "auctioneer",
          //   })
          // );

          //token
          let tokenEncodeData = btoa(responseData.token.toString());
          sessionStorage.setItem("argument1", tokenEncodeData);
          localStorage.setItem("argument1", tokenEncodeData);
          // localStorage.setItem("expireLoggedTokenTime", "Closed");
          axiosMain.defaults.headers[
            "Authorization"
          ] = `Bearer ${responseData.token.toString()}`;
          //refresh token time
          let refreshTokenTime = btoa(
            responseData.tokenExpirationOn.toString()
          );
          sessionStorage.setItem("argument12", refreshTokenTime);
          // let refreshTokenTime1 = btoa(responseData.tokenExpirationOn.toString());
          localStorage.setItem("argument12", refreshTokenTime);
          // let tokenEncodeData1 = btoa(responseData.token.toString());
          //userId

          let userIdEncodeData = btoa(responseData.userId.toString());
          sessionStorage.setItem("argument2", userIdEncodeData);
          localStorage.setItem("argument2", userIdEncodeData);

          //userType
          let userTypeEncodeData = btoa(responseData.usertypeId.toString());
          sessionStorage.setItem("argument3", userTypeEncodeData);
          localStorage.setItem("argument3", userTypeEncodeData);

          //userCode
          let userCodeEncodeData = btoa(responseData.userCode.toString());
          sessionStorage.setItem("argument4", userCodeEncodeData);
          localStorage.setItem("argument4", userCodeEncodeData);

          //userName
          if (responseData.userName != null) {
            let userNameEncodeData = btoa(responseData.userName.toString());
            sessionStorage.setItem("argument5", userNameEncodeData);
            localStorage.setItem("argument5", userNameEncodeData);
          }

          // Role
          if (responseData.roleCode != null) {
            let userNameEncodeData =
              responseData.roleCode && btoa(responseData.roleCode.toString());
            localStorage.setItem("argument6", userNameEncodeData);
            sessionStorage.setItem("argument6", userNameEncodeData);
            sessionStorage.setItem(
              "argument8",
              responseData.usertypeId && btoa(responseData.usertypeId)
            );
            localStorage.setItem(
              "argument8",
              responseData.usertypeId && btoa(responseData.usertypeId)
            );
          }

          //trackLoginId
          let trackLoginIdData =
            responseData.trackLoginId &&
            btoa(responseData.trackLoginId.toString());
          sessionStorage.setItem("argument7", trackLoginIdData);
          localStorage.setItem("argument7", trackLoginIdData);
          let auctionCenterIds =
            responseData.auctionCenterId &&
            btoa(responseData.auctionCenterId.toString());
          sessionStorage.setItem("auctiocenterId", auctionCenterIds);
          localStorage.setItem("auctiocenterId", auctionCenterIds);

          let isLogged = responseData.isFirstLogin;
          sessionStorage.setItem("isLogged", isLogged);
          localStorage.setItem("isLogged", isLogged);

          let isActiveEncodeData =
            responseData.roleCode && btoa(responseData.isActive.toString());
          localStorage.setItem("argument13", isActiveEncodeData);
          sessionStorage.setItem("argument13", isActiveEncodeData);

          CustomToast.success(response.data.message);
          // window.location.pathname = "/dashboard";
          yield put(loginActionSuccess(response.data));
          yield put(allactions.toggleActionFail());
          yield put(LoginLoaderStutas(true));
        } else {
          CustomToast.error("Unauthorized access");
          yield put(loginActionFail("Unauthorized access"));
        }
      } else {
        CustomToast.error(response.data.message);
        yield put(loginActionFail(response.data.message));
      }
    } else {
      yield put(loginActionFail(response.message));
    }
  } catch (err) {
    console.log(err);
  } finally {
    yield put(hideLoader());
  }
}

function* fetchToken(action) {
  try {
    // Make the API call using Axios
    const response = yield call(fetchTokenAPI, action.payload.userCode);
    yield put(fetchTokenSuccess(response.data.responseData));
  } catch (error) {
    yield put(fetchTokenFailure(error));
  }
}

// Function to make API call using Axios
function fetchTokenAPI(userCode) {
  return axiosMain.post("/admin/auth/refreshToken", {
    userCode,
  });
}
function* logoutSaga() {
  try {
    // Make the API request to log out
    const response = yield call(axiosMain.post, `/apigateway/logout`, {});
    if (response.data == "Logged out successfully and token invalidated.") {
      yield put(allactions.logoutSuccess(response));
    } else {
      yield put(allactions.logoutFailure("logout fail"));
    }
  } catch (error) {
    yield put(allactions.logoutFailure(error));
  }
}

// Encrypt data function
const decryptData = (data) => {
  const secretKey = "08090a0b0c0d0e0f"; // Same secret key used for encryption/decryption
  const IV_KEY = "18191a1b1c1d1e1f"; // IV key
  try {
    const stringData = typeof data === "string" ? data : JSON.stringify(data);
    const key = CryptoJS.enc.Utf8.parse(secretKey);
    const iv = CryptoJS.enc.Utf8.parse(IV_KEY);

    // Decrypt the data
    const decryptedData = CryptoJS.AES.decrypt(stringData, key, { iv });

    // Convert decrypted data to a UTF-8 string
    const decryptedString = decryptedData.toString(CryptoJS.enc.Utf8);

    // Assuming the decrypted string is a JSON, parse it
    if (decryptedString) {
      return JSON.parse(decryptedString); // Return the parsed JSON object
    } else {
      return null; // Return null if decryption fails or the result is empty
    }
  } catch (error) {
    console.error("Error decrypting data:", error);
    return null;
  }
};

export default function* authSaga() {
  yield takeEvery(actionLabels.LOGIN_ACTION, loginSaga);
  yield takeEvery(actionLabels.FETCH_TOKEN_REQUEST, fetchToken);
  yield takeEvery(actionLabels.LOGOUT_REQUEST, logoutSaga);
}
